import { Icon, IconProps } from "./Icon";

export function IconMagnifyingGlass(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M21.3 24a1.27 1.27 0 0 1-.91-.38l-7.45-7.47.71-.71 7.45 7.48a.32.32 0 0 0 .2.08.28.28 0 0 0 .2-.08l1.42-1.42a.3.3 0 0 0 0-.41l-7.5-7.53.7-.7 7.51 7.52a1.29 1.29 0 0 1 0 1.82l-1.42 1.42a1.24 1.24 0 0 1-.91.38ZM8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm0 15a7 7 0 1 1 7-7 7 7 0 0 1-7 7Z" />
    </Icon>
  );
}
